import React from 'react'
import { Container } from '@jsluna/react'
import config from './../../utils/config'

const ConsentAdmin = () => {
  const isConsentApproved = () => {
    const responseProperties = window.location.href.split('&')
    return (responseProperties.filter(property => property.toLowerCase() === 'admin_consent=True'.toLowerCase())).length > 0
  }

  const getConsentApprovedMessage = () => {
    if (isConsentApproved()) {
      return (
        <p>Consent approved</p>
      )
    }
    return (
      <div>
        <p>Confirmation is required for the Digital Sign in Book application to access Azure Active Directory properties.</p>
        <p>By selecting Proceed, you will be taken to an Azure login page where you should login as an Administrator for the {config.getTenant()} tenant.
        Upon successful login you will be asked to confirm that the application can access the listed properties.</p>
        <a href={config.getConsentAdminUrl()}>Proceed</a>
      </div>
    )
  }

  return (
    <Container soft>
      <div className="ln-o-article">
        <div className="ln-c-card ln-u-soft">
          <h1>Administrator Consent - DSiB</h1>
          { getConsentApprovedMessage() }
        </div>
      </div>
    </Container>
  )
}

export default ConsentAdmin



// WEBPACK FOOTER //
// ./src/components/ConsentAdmin/index.jsx